// extracted by mini-css-extract-plugin
export default {"header":"index_header_pzfRi","main":"index_main_bJT0z","logo":"index_logo_AF6Sl"};